export const password = "amninder&jaskaran"; // enter your password here to deleet the room